const LG_BREAKPOINT = 992

export function syncNavbarHeight (navbarRootEl) {
  const bar = (navbarRootEl && navbarRootEl.querySelector('.ga-navbar')) ||
    document.querySelector('.ga-navbar')
  if (!bar) return
  const height = Math.ceil(bar.getBoundingClientRect().height)
  if (height > 0) {
    document.documentElement.style.setProperty('--ga-navbar-offset', `${height}px`)
  }
}

export function syncNavbarLayoutColumns (navbarRootEl) {
  if (!navbarRootEl || window.innerWidth < LG_BREAKPOINT) {
    clearNavbarLayoutColumns()
    return
  }

  const row = navbarRootEl.querySelector('.ga-layout-row--navbar')
  if (!row) {
    return
  }

  const left = row.querySelector('.ga-layout-gutter--left')
  const right = row.querySelector('.ga-layout-gutter--right')
  if (!left || !right) {
    return
  }

  const root = document.documentElement
  root.style.setProperty('--ga-layout-left-col', `${left.offsetWidth}px`)
  root.style.setProperty('--ga-layout-right-col', `${right.offsetWidth}px`)
}

export function clearNavbarLayoutColumns () {
  const root = document.documentElement
  root.style.removeProperty('--ga-layout-left-col')
  root.style.removeProperty('--ga-layout-right-col')
}

export function installNavbarLayoutSync (navbarRootEl) {
  const run = () => {
    syncNavbarLayoutColumns(navbarRootEl)
    syncNavbarHeight(navbarRootEl)
  }

  run()
  window.addEventListener('resize', run)

  let observer = null
  const bar = navbarRootEl && navbarRootEl.querySelector('.ga-navbar')
  const row = navbarRootEl && navbarRootEl.querySelector('.ga-layout-row--navbar')
  if (typeof ResizeObserver !== 'undefined') {
    observer = new ResizeObserver(run)
    if (bar) observer.observe(bar)
    if (row) observer.observe(row)
  }

  return () => {
    window.removeEventListener('resize', run)
    if (observer) {
      observer.disconnect()
    }
    clearNavbarLayoutColumns()
  }
}
